import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiSkeleton } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-examinations-skeleton',
  imports: [TuiSkeleton],
  templateUrl: './examinations-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExaminationsSkeletonComponent {}
